import type { CostAppointedBy, CostChangeCause, CostChangeKind, CostChangeStatus, CostContractKind, CostContractStatus, CostContractType, CostInvoiceStatus, CostApplicationStatus, CostRfqStatus } from '../types'

// ---- Labels (literal maps: the i18n test finds keys by scanning literals) ----

export const CONTRACT_STATUSES: CostContractStatus[] = ['DRAFT', 'ACTIVE', 'CLOSED']
export const CONTRACT_STATUS_KEY: Record<CostContractStatus, string> = {
  DRAFT: 'CostControl_contract_status_DRAFT',
  ACTIVE: 'CostControl_contract_status_ACTIVE',
  CLOSED: 'CostControl_contract_status_CLOSED',
}
export const CONTRACT_KIND_KEY: Record<CostContractKind, string> = { MAIN: 'CostControl_contract_kind_MAIN', SUB: 'CostControl_contract_kind_SUB' }
export const APPOINTED_BY_KEY: Record<CostAppointedBy, string> = {
  GENERAL_CONTRACTOR: 'CostControl_appointed_GENERAL_CONTRACTOR',
  INVESTOR: 'CostControl_appointed_INVESTOR',
}
export const CONTRACT_TYPE_KEY: Record<CostContractType, string> = {
  LUMP_SUM: 'CostControl_contract_type_LUMP_SUM',
  OPEN_BOOK: 'CostControl_contract_type_OPEN_BOOK',
  REMEASURED: 'CostControl_contract_type_REMEASURED',
  PROVISIONAL_SUM: 'CostControl_contract_type_PROVISIONAL_SUM',
}

export const CHANGE_KINDS: CostChangeKind[] = ['BUDGET_CHANGE', 'CONTRACT_CHANGE', 'TRANSFER', 'POTENTIAL']
export const CHANGE_KIND_KEY: Record<CostChangeKind, string> = {
  BUDGET_CHANGE: 'CostControl_change_kind_BUDGET_CHANGE',
  CONTRACT_CHANGE: 'CostControl_change_kind_CONTRACT_CHANGE',
  TRANSFER: 'CostControl_change_kind_TRANSFER',
  POTENTIAL: 'CostControl_change_kind_POTENTIAL',
}
export const CHANGE_CAUSES: CostChangeCause[] = ['DESIGN_CHANGE', 'UNFORESEEN', 'CLIENT_REQUEST', 'OTHER']
export const CHANGE_CAUSE_KEY: Record<CostChangeCause, string> = {
  DESIGN_CHANGE: 'CostControl_change_cause_DESIGN_CHANGE',
  UNFORESEEN: 'CostControl_change_cause_UNFORESEEN',
  CLIENT_REQUEST: 'CostControl_change_cause_CLIENT_REQUEST',
  OTHER: 'CostControl_change_cause_OTHER',
}
export const CHANGE_STATUSES: CostChangeStatus[] = ['DRAFT', 'PENDING', 'APPROVED', 'REJECTED']
export const CHANGE_STATUS_KEY: Record<CostChangeStatus, string> = {
  DRAFT: 'CostControl_change_status_DRAFT',
  PENDING: 'CostControl_change_status_PENDING',
  APPROVED: 'CostControl_change_status_APPROVED',
  REJECTED: 'CostControl_change_status_REJECTED',
}
export const INVOICE_STATUSES: CostInvoiceStatus[] = ['PENDING', 'APPROVED', 'PAID']
export const INVOICE_STATUS_KEY: Record<CostInvoiceStatus, string> = {
  PENDING: 'CostControl_invoice_status_PENDING',
  APPROVED: 'CostControl_invoice_status_APPROVED',
  PAID: 'CostControl_invoice_status_PAID',
}
export const LEDGER_KIND_KEY: Record<'INVOICE' | 'EXPENSE', string> = { INVOICE: 'CostControl_ledger_kind_INVOICE', EXPENSE: 'CostControl_ledger_kind_EXPENSE' }

export const APPLICATION_STATUS_KEY: Record<CostApplicationStatus, string> = {
  DRAFT: 'CostControl_application_status_DRAFT',
  SUBMITTED: 'CostControl_application_status_SUBMITTED',
  CERTIFIED: 'CostControl_application_status_CERTIFIED',
}

export const RFQ_STATUSES: CostRfqStatus[] = ['OPEN', 'AWARDED', 'CANCELLED']
export const RFQ_STATUS_KEY: Record<CostRfqStatus, string> = {
  OPEN: 'CostControl_rfq_status_OPEN',
  AWARDED: 'CostControl_rfq_status_AWARDED',
  CANCELLED: 'CostControl_rfq_status_CANCELLED',
}
